module.exports = {"450206100":"拉堡镇","450206102":"百朋镇","450206103":"成团镇","450206104":"洛满镇","450206105":"流山镇","450206106":"三都镇","450206107":"里高镇","450206108":"进德镇","450206109":"穿山镇","450206110":"土博镇","450206400":"新兴工业园","450206401":"新兴农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450206.json
// module id = 2085
// module chunks = 0